/* eslint-disable @next/next/no-img-element */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Image from '@base/FutureImage';
import H1 from '@base/H1/H1';
import H4 from '@base/H4/H4';
import H5 from '@base/H5/H5';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import { BENEFITS } from '@cont/RankPredictor/constant';
import GoalCmsContent from '@cont/PreSubscribed/GoalCmsContent';

const Wrapper = styled.div`
  padding-top: ${Spacings.SPACING_20B};
  padding-bottom: ${Spacings.SPACING_25B};
  padding-left: 15vw;
  padding-right: 15vw;
  text-align: left;

  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B};
    padding-top: ${Spacings.SPACING_9B};
  }
`;

const Heading = styled(H1)`
  width: 395px;
  font-size: ${Spacings.SPACING_10B};
  margin-bottom: ${Spacings.SPACING_5B};

  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
    width: 100%;
    font-size: ${Fonts.H3};
  }
`;

const SubText = styled(H5)`
  margin-bottom: ${Spacings.SPACING_3B};
  font-weight: ${Fonts.REGULAR};
`;

const KeyBenefits = styled.div`
  display: flex;
  text-align: left;
  margin-top: ${Spacings.SPACING_16B};
  div:not(:last-child) {
    margin-right: ${Spacings.SPACING_14B};
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
    flex-direction: column;
  }
`;

const Benefit = styled.div`
  flex: 1;
  ${mediaQuery.uptoMobile} {
    margin-right: 0;
    margin-bottom: ${Spacings.SPACING_14B};
  }
  h4 {
    margin-bottom: ${Spacings.SPACING_2B};
  }
`;

const BenefitImage = styled(Image)`
  margin-bottom: ${Spacings.SPACING_4B};
`;

const AboutUnacademy = ({ benefits, headingText }) => (
  <>
    <Wrapper>
      <Heading as="h2">{headingText}</Heading>
      <KeyBenefits>
        {benefits?.map((benefit, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Benefit key={i}>
            <BenefitImage width={80} height={80} src={benefit.img} alt="" />
            <H4>{benefit.heading}</H4>
            <SubText>{benefit.subtext}</SubText>
          </Benefit>
        ))}
      </KeyBenefits>
      <GoalCmsContent width="100%" />
    </Wrapper>
  </>
);

export default AboutUnacademy;

AboutUnacademy.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.any),
  headingText: PropTypes.string
};
AboutUnacademy.defaultProps = {
  benefits: BENEFITS,
  headingText: 'India’s largest learning platform'
};
